module.exports = __webpack_public_path__ + "img/RCloudPHPMyAdmin.f19df281.png";